import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpMainService } from '../http-main.service';
import {
  ProfileResponseModel,
  UserRequestModel,
  VerifyPhoneRequestModel,
} from '@itb-monorepo/models';
import { DocumentRequestModel } from '@itb-monorepo/models';
import { HttpEvent } from '@angular/common/http';

@Injectable()
export class ProfilesService {
  baseUrl = '/member/';
  private _HttpMainService = inject(HttpMainService);

  setUserProfile(model: UserRequestModel): Observable<ProfileResponseModel> {
    return this._HttpMainService.post(
      this.baseUrl + 'v1/profiles/current',
      model
    );
  }

  update(model: UserRequestModel): Observable<ProfileResponseModel> {
    return this._HttpMainService.put(
      this.baseUrl + 'v1/profiles/current',
      model
    );
  }

  uploadDocument(
    model: DocumentRequestModel
  ): Observable<HttpEvent<ProfileResponseModel>> {
    const formData = new FormData();
    formData.append('file', model.file);
    return this._HttpMainService.putFormData(
      this.baseUrl + 'v1/profiles/current/documents/single',
      formData
    );
  }

  getFile(userId: string): Observable<any> {
    return this._HttpMainService.getFile(
      this.baseUrl + 'v1/profiles/' + userId + '/documents/single'
    );
  }

  verifyPhoneCurrentUser(
    userId: string,
    model: VerifyPhoneRequestModel
  ): Observable<ProfileResponseModel> {
    return this._HttpMainService.patch(
      this.baseUrl + `v1/profiles/${userId}/phones/single`,
      model
    );
  }
}
